import React from "react";
import styled from "styled-components";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

const Container = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const LoginLoading = () => {
  return (
    <Container>
      <Loader type="ThreeDots" color="#00BFFF" height={200} width={200} />
    </Container>
  );
};
